import { BibAssign } from '@/objects/generated/classes/BibAssign';
import { BibAssignPreview } from '@/objects/generated/classes/BibAssignPreview';
import { BibAssignSort } from '@/objects/generated/classes/BibAssignSort';
import { BlockedBib } from '@/objects/generated/classes/BlockedBib';
import { Category } from '@/objects/generated/classes/Category';
import { CategoryGroupConnection } from '@/objects/generated/classes/CategoryGroupConnection';
import { Club } from '@/objects/generated/classes/Club';
import { CommunicationToApprove } from '@/objects/generated/classes/CommunicationToApprove';
import { ContestantAndRaceContestantTime } from '@/objects/generated/classes/ContestantAndRaceContestantTime';
import { ContestantBase } from '@/objects/generated/classes/ContestantBase';
import { ContestantFavorite } from '@/objects/generated/classes/ContestantFavorite';
import { Country } from '@/objects/generated/classes/Country';
import { DeviceEvent } from '@/objects/generated/classes/DeviceEvent';
import { DeviceStation } from '@/objects/generated/classes/DeviceStation';
import { Discipline } from '@/objects/generated/classes/Discipline';
import { EventImplementation } from '@/objects/generated/classes/EventImplementation';
import { Eventinfo } from '@/objects/generated/classes/Eventinfo';
import { EventinfoBase } from '@/objects/generated/classes/EventinfoBase';
import { EventinfoSearchlistItem } from '@/objects/generated/classes/EventinfoSearchlistItem';
import { EventinfoText } from '@/objects/generated/classes/EventinfoText';
import { EventLiveLogos } from '@/objects/generated/classes/EventLiveLogos';
import { EventLiveStyles } from '@/objects/generated/classes/EventLiveStyles';
import { EventProductionDevice } from '@/objects/generated/classes/EventProductionDevice';
import { EventSettings } from '@/objects/generated/classes/EventSettings';
import { EventSetup } from '@/objects/generated/classes/EventSetup';
import { EventTeam } from '@/objects/generated/classes/EventTeam';
import { Federation } from '@/objects/generated/classes/Federation';
import { FileDetails } from '@/objects/generated/classes/FileDetails';
import { FISDataCategory } from '@/objects/generated/classes/FISDataCategory';
import { FISDataEvent } from '@/objects/generated/classes/FISDataEvent';
import { FISDataRace } from '@/objects/generated/classes/FISDataRace';
import { FocusEvent } from '@/objects/generated/classes/FocusEvent';
import { GPIOReading } from '@/objects/generated/classes/GPIOReading';
import { Group } from '@/objects/generated/classes/Group';
import { GroupWithCount } from '@/objects/generated/classes/GroupWithCount';
import { HeatPlan } from '@/objects/generated/classes/HeatPlan';
import { HeatPlanBackupItem } from '@/objects/generated/classes/HeatPlanBackupItem';
import { HeatPlanCategory } from '@/objects/generated/classes/HeatPlanCategory';
import { HeatSortPlan } from '@/objects/generated/classes/HeatSortPlan';
import { IBUDataCategory } from '@/objects/generated/classes/IBUDataCategory';
import { IBUDataEvent } from '@/objects/generated/classes/IBUDataEvent';
import { JsonSettings } from '@/objects/generated/classes/JsonSettings';
import { Licence } from '@/objects/generated/classes/Licence';
import { LicenceSearchItem } from '@/objects/generated/classes/LicenceSearchItem';
import { MailRequest } from '@/objects/generated/classes/MailRequest';
import { ManagerReport } from '@/objects/generated/classes/ManagerReport';
import { MapTrack } from '@/objects/generated/classes/MapTrack';
import { MatrixShootingCellWarningsAcknowledgement } from '@/objects/generated/classes/MatrixShootingCellWarningsAcknowledgement';
import { Organizer } from '@/objects/generated/classes/Organizer';
import { Participant } from '@/objects/generated/classes/Participant';
import { ParticipantId } from '@/objects/generated/classes/ParticipantId';
import { ParticipantIDType } from '@/objects/generated/classes/ParticipantIDType';
import { ParticipantWithLicences } from '@/objects/generated/classes/ParticipantWithLicences';
import { PointType } from '@/objects/generated/classes/PointType';
import { Profile } from '@/objects/generated/classes/Profile';
import { Race } from '@/objects/generated/classes/Race';
import { RaceContestant } from '@/objects/generated/classes/RaceContestant';
import { RaceContestantComplete } from '@/objects/generated/classes/RaceContestantComplete';
import { RaceContestantDetails } from '@/objects/generated/classes/RaceContestantDetails';
import { RaceContestantPoints } from '@/objects/generated/classes/RaceContestantPoints';
import { RaceContestantTrackingUpdateRequest } from '@/objects/generated/classes/RaceContestantTrackingUpdateRequest';
import { RaceTransferRule } from '@/objects/generated/classes/RaceTransferRule';
import { RankingCategory } from '@/objects/generated/classes/RankingCategory';
import { Region } from '@/objects/generated/classes/Region';
import { RelayTeamContestant } from '@/objects/generated/classes/RelayTeamContestant';
import { Report } from '@/objects/generated/classes/Report';
import { ReportParameter } from '@/objects/generated/classes/ReportParameter';
import { ResultSetup } from '@/objects/generated/classes/ResultSetup';
import { ResultSetupRace } from '@/objects/generated/classes/ResultSetupRace';
import { Scoring } from '@/objects/generated/classes/Scoring';
import { SeedingList } from '@/objects/generated/classes/SeedingList';
import { Series } from '@/objects/generated/classes/Series';
import { ShootingResult } from '@/objects/generated/classes/ShootingResult';
import { SignupSettings } from '@/objects/generated/classes/SignupSettings';
import { Sport } from '@/objects/generated/classes/Sport';
import { Sportlevel } from '@/objects/generated/classes/Sportlevel';
import { StartingNumber } from '@/objects/generated/classes/StartingNumber';
import { StartingNumberHistory } from '@/objects/generated/classes/StartingNumberHistory';
import { Station } from '@/objects/generated/classes/Station';
import { StationAlias } from '@/objects/generated/classes/StationAlias';
import { StationDetails } from '@/objects/generated/classes/StationDetails';
import { StationDeviceStatus } from '@/objects/generated/classes/StationDeviceStatus';
import { StationDeviceStatusWithCount } from '@/objects/generated/classes/StationDeviceStatusWithCount';
import { StationRole } from '@/objects/generated/classes/StationRole';
import { StationRoleOverride } from '@/objects/generated/classes/StationRoleOverride';
import { StationType } from '@/objects/generated/classes/StationType';
import { Timepenalty } from '@/objects/generated/classes/Timepenalty';
import { TimepenaltyType } from '@/objects/generated/classes/TimepenaltyType';
import { TimingDevice } from '@/objects/generated/classes/TimingDevice';
import { TrackingDevice } from '@/objects/generated/classes/TrackingDevice';
import { TrackingDeviceWithRaceContestantPosition } from '@/objects/generated/classes/TrackingDeviceWithRaceContestantPosition';
import { TrackingFilterRequest } from '@/objects/generated/classes/TrackingFilterRequest';
import { TrackingResultSetup } from '@/objects/generated/classes/TrackingResultSetup';
import { TrainingLane } from '@/objects/generated/classes/TrainingLane';
import { TrainingLaneCategoryGroup } from '@/objects/generated/classes/TrainingLaneCategoryGroup';
import { TrainingLaneGroup } from '@/objects/generated/classes/TrainingLaneGroup';
import { UnknownTag } from '@/objects/generated/classes/UnknownTag';

const baseEntityClasses = new Map<string, string>();

baseEntityClasses.set(BibAssign.NAME_OF_CLASS, 'BibAssign');
baseEntityClasses.set(BibAssignPreview.NAME_OF_CLASS, 'BibAssignPreview');
baseEntityClasses.set(BibAssignSort.NAME_OF_CLASS, 'BibAssignSort');
baseEntityClasses.set(BlockedBib.NAME_OF_CLASS, 'BlockedBib');
baseEntityClasses.set(Category.NAME_OF_CLASS, 'Category');
baseEntityClasses.set(CategoryGroupConnection.NAME_OF_CLASS, 'CategoryGroupConnection');
baseEntityClasses.set(Club.NAME_OF_CLASS, 'Club');
baseEntityClasses.set(CommunicationToApprove.NAME_OF_CLASS, 'CommunicationToApprove');
baseEntityClasses.set(ContestantAndRaceContestantTime.NAME_OF_CLASS, 'ContestantAndRaceContestantTime');
baseEntityClasses.set(ContestantBase.NAME_OF_CLASS, 'ContestantBase');
baseEntityClasses.set(ContestantFavorite.NAME_OF_CLASS, 'ContestantFavorite');
baseEntityClasses.set(Country.NAME_OF_CLASS, 'Country');
baseEntityClasses.set(DeviceEvent.NAME_OF_CLASS, 'DeviceEvent');
baseEntityClasses.set(DeviceStation.NAME_OF_CLASS, 'DeviceStation');
baseEntityClasses.set(Discipline.NAME_OF_CLASS, 'Discipline');
baseEntityClasses.set(EventImplementation.NAME_OF_CLASS, 'EventImplementation');
baseEntityClasses.set(Eventinfo.NAME_OF_CLASS, 'Eventinfo');
baseEntityClasses.set(EventinfoBase.NAME_OF_CLASS, 'EventinfoBase');
baseEntityClasses.set(EventinfoSearchlistItem.NAME_OF_CLASS, 'EventinfoSearchlistItem');
baseEntityClasses.set(EventinfoText.NAME_OF_CLASS, 'EventinfoText');
baseEntityClasses.set(EventLiveLogos.NAME_OF_CLASS, 'EventLiveLogos');
baseEntityClasses.set(EventLiveStyles.NAME_OF_CLASS, 'EventLiveStyles');
baseEntityClasses.set(EventProductionDevice.NAME_OF_CLASS, 'EventProductionDevice');
baseEntityClasses.set(EventSettings.NAME_OF_CLASS, 'EventSettings');
baseEntityClasses.set(EventSetup.NAME_OF_CLASS, 'EventSetup');
baseEntityClasses.set(EventTeam.NAME_OF_CLASS, 'EventTeam');
baseEntityClasses.set(Federation.NAME_OF_CLASS, 'Federation');
baseEntityClasses.set(FileDetails.NAME_OF_CLASS, 'FileDetails');
baseEntityClasses.set(FISDataCategory.NAME_OF_CLASS, 'FISDataCategory');
baseEntityClasses.set(FISDataEvent.NAME_OF_CLASS, 'FISDataEvent');
baseEntityClasses.set(FISDataRace.NAME_OF_CLASS, 'FISDataRace');
baseEntityClasses.set(FocusEvent.NAME_OF_CLASS, 'FocusEvent');
baseEntityClasses.set(GPIOReading.NAME_OF_CLASS, 'GPIOReading');
baseEntityClasses.set(Group.NAME_OF_CLASS, 'Group');
baseEntityClasses.set(GroupWithCount.NAME_OF_CLASS, 'GroupWithCount');
baseEntityClasses.set(HeatPlan.NAME_OF_CLASS, 'HeatPlan');
baseEntityClasses.set(HeatPlanBackupItem.NAME_OF_CLASS, 'HeatPlanBackupItem');
baseEntityClasses.set(HeatPlanCategory.NAME_OF_CLASS, 'HeatPlanCategory');
baseEntityClasses.set(HeatSortPlan.NAME_OF_CLASS, 'HeatSortPlan');
baseEntityClasses.set(IBUDataCategory.NAME_OF_CLASS, 'IBUDataCategory');
baseEntityClasses.set(IBUDataEvent.NAME_OF_CLASS, 'IBUDataEvent');
baseEntityClasses.set(JsonSettings.NAME_OF_CLASS, 'JsonSettings');
baseEntityClasses.set(Licence.NAME_OF_CLASS, 'Licence');
baseEntityClasses.set(LicenceSearchItem.NAME_OF_CLASS, 'LicenceSearchItem');
baseEntityClasses.set(MailRequest.NAME_OF_CLASS, 'MailRequest');
baseEntityClasses.set(ManagerReport.NAME_OF_CLASS, 'ManagerReport');
baseEntityClasses.set(MapTrack.NAME_OF_CLASS, 'MapTrack');
baseEntityClasses.set(MatrixShootingCellWarningsAcknowledgement.NAME_OF_CLASS, 'MatrixShootingCellWarningsAcknowledgement');
baseEntityClasses.set(Organizer.NAME_OF_CLASS, 'Organizer');
baseEntityClasses.set(Participant.NAME_OF_CLASS, 'Participant');
baseEntityClasses.set(ParticipantId.NAME_OF_CLASS, 'ParticipantId');
baseEntityClasses.set(ParticipantIDType.NAME_OF_CLASS, 'ParticipantIDType');
baseEntityClasses.set(ParticipantWithLicences.NAME_OF_CLASS, 'ParticipantWithLicences');
baseEntityClasses.set(PointType.NAME_OF_CLASS, 'PointType');
baseEntityClasses.set(Profile.NAME_OF_CLASS, 'Profile');
baseEntityClasses.set(Race.NAME_OF_CLASS, 'Race');
baseEntityClasses.set(RaceContestant.NAME_OF_CLASS, 'RaceContestant');
baseEntityClasses.set(RaceContestantComplete.NAME_OF_CLASS, 'RaceContestantComplete');
baseEntityClasses.set(RaceContestantDetails.NAME_OF_CLASS, 'RaceContestantDetails');
baseEntityClasses.set(RaceContestantPoints.NAME_OF_CLASS, 'RaceContestantPoints');
baseEntityClasses.set(RaceContestantTrackingUpdateRequest.NAME_OF_CLASS, 'RaceContestantTrackingUpdateRequest');
baseEntityClasses.set(RaceTransferRule.NAME_OF_CLASS, 'RaceTransferRule');
baseEntityClasses.set(RankingCategory.NAME_OF_CLASS, 'RankingCategory');
baseEntityClasses.set(Region.NAME_OF_CLASS, 'Region');
baseEntityClasses.set(RelayTeamContestant.NAME_OF_CLASS, 'RelayTeamContestant');
baseEntityClasses.set(Report.NAME_OF_CLASS, 'Report');
baseEntityClasses.set(ReportParameter.NAME_OF_CLASS, 'ReportParameter');
baseEntityClasses.set(ResultSetup.NAME_OF_CLASS, 'ResultSetup');
baseEntityClasses.set(ResultSetupRace.NAME_OF_CLASS, 'ResultSetupRace');
baseEntityClasses.set(Scoring.NAME_OF_CLASS, 'Scoring');
baseEntityClasses.set(SeedingList.NAME_OF_CLASS, 'SeedingList');
baseEntityClasses.set(Series.NAME_OF_CLASS, 'Series');
baseEntityClasses.set(ShootingResult.NAME_OF_CLASS, 'ShootingResult');
baseEntityClasses.set(SignupSettings.NAME_OF_CLASS, 'SignupSettings');
baseEntityClasses.set(Sport.NAME_OF_CLASS, 'Sport');
baseEntityClasses.set(Sportlevel.NAME_OF_CLASS, 'Sportlevel');
baseEntityClasses.set(StartingNumber.NAME_OF_CLASS, 'StartingNumber');
baseEntityClasses.set(StartingNumberHistory.NAME_OF_CLASS, 'StartingNumberHistory');
baseEntityClasses.set(Station.NAME_OF_CLASS, 'Station');
baseEntityClasses.set(StationAlias.NAME_OF_CLASS, 'StationAlias');
baseEntityClasses.set(StationDetails.NAME_OF_CLASS, 'StationDetails');
baseEntityClasses.set(StationDeviceStatus.NAME_OF_CLASS, 'StationDeviceStatus');
baseEntityClasses.set(StationDeviceStatusWithCount.NAME_OF_CLASS, 'StationDeviceStatusWithCount');
baseEntityClasses.set(StationRole.NAME_OF_CLASS, 'StationRole');
baseEntityClasses.set(StationRoleOverride.NAME_OF_CLASS, 'StationRoleOverride');
baseEntityClasses.set(StationType.NAME_OF_CLASS, 'StationType');
baseEntityClasses.set(Timepenalty.NAME_OF_CLASS, 'Timepenalty');
baseEntityClasses.set(TimepenaltyType.NAME_OF_CLASS, 'TimepenaltyType');
baseEntityClasses.set(TimingDevice.NAME_OF_CLASS, 'TimingDevice');
baseEntityClasses.set(TrackingDevice.NAME_OF_CLASS, 'TrackingDevice');
baseEntityClasses.set(TrackingDeviceWithRaceContestantPosition.NAME_OF_CLASS, 'TrackingDeviceWithRaceContestantPosition');
baseEntityClasses.set(TrackingFilterRequest.NAME_OF_CLASS, 'TrackingFilterRequest');
baseEntityClasses.set(TrackingResultSetup.NAME_OF_CLASS, 'TrackingResultSetup');
baseEntityClasses.set(TrainingLane.NAME_OF_CLASS, 'TrainingLane');
baseEntityClasses.set(TrainingLaneCategoryGroup.NAME_OF_CLASS, 'TrainingLaneCategoryGroup');
baseEntityClasses.set(TrainingLaneGroup.NAME_OF_CLASS, 'TrainingLaneGroup');
baseEntityClasses.set(UnknownTag.NAME_OF_CLASS, 'UnknownTag');

/**
 * All BaseObjs that have EventID. Lookup by the generated name
 * Lookup by the generated name
 */
export const baseEntityNamesThatHasEventID = new Set([
    'BibAssign',
    'BibAssignSort',
    'BlockedBib',
    'Category',
    'ContestantBase',
    'ContestantFavorite',
    'EventImplementation',
    'EventinfoText',
    'EventSettings',
    'EventSetup',
    'EventTeam',
    'FISDataEvent',
    'GPIOReading',
    'Group',
    'GroupWithCount',
    'HeatPlan',
    'IBUDataCategory',
    'IBUDataEvent',
    'MapTrack',
    'Race',
    'RaceContestant',
    'RaceContestantComplete',
    'RaceContestantDetails',
    'RaceContestantPoints',
    'RaceTransferRule',
    'RelayTeamContestant',
    'ResultSetup',
    'ShootingResult',
    'SignupSettings',
    'StartingNumber',
    'StartingNumberHistory',
    'Station',
    'StationDetails',
    'StationRole',
    'Timepenalty',
    'TrackingResultSetup',
    'TrainingLane',
    'TrainingLaneCategoryGroup',
    'TrainingLaneGroup',
    'UnknownTag',
]);

export default baseEntityClasses;
